import { render, staticRenderFns } from "./transfer-form.vue?vue&type=template&id=0f731dc9&scoped=true&"
import script from "./transfer-form.vue?vue&type=script&lang=js&"
export * from "./transfer-form.vue?vue&type=script&lang=js&"
import style0 from "./transfer-form.vue?vue&type=style&index=0&id=0f731dc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f731dc9",
  null
  
)

export default component.exports